export const getFontSizeList = () => {
    const min = 16;
    const max = 224;
    const step = 4;

    const ret: number[] = [];
    for (let i = min; i <= max; i += step) {
        ret.push(i);
    }
    return ret;
};
